import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  getDecodeMakes,
  getDecodeMakesKey,
  getDecodeModelsKey,
  getDecodeModels,
  getDecodeShortTrimsKey,
  getDecodeShortTrims,
} from '../../../../api-client/integration'

export default function useManualEntryOptions({ year, makeId, modelId }) {
  const { data: makesResponse = [], isFetching: isMakesFetching } = useQuery({
    queryKey: getDecodeMakesKey + year,
    queryFn: () => getDecodeMakes({ year: year }),
    enabled: !!year,
  })
  const makeOptions = useMemo(
    () => makesResponse.map(({ id, name }) => ({ label: name, value: id })),
    [makesResponse],
  )

  const { data: modelsResponse = [], isFetching: isModelsFetching } = useQuery({
    queryKey: getDecodeModelsKey + makeId,
    queryFn: () => getDecodeModels({ year: year, makeId: makeId }),
    enabled: !!makeId,
  })
  const modelOptions = useMemo(
    () => modelsResponse.map(({ id, name }) => ({ label: name, value: id })),
    [modelsResponse],
  )

  const { data: shortTrimsResponse = [], isFetching: isShortTrimsFetching } = useQuery({
    queryKey: getDecodeShortTrimsKey + modelId,
    queryFn: () => getDecodeShortTrims({ modelId: modelId }),
    enabled: !!modelId,
  })
  const shortTrimOptions = useMemo(
    () => shortTrimsResponse.map(({ name }) => ({ label: name, value: name })),
    [shortTrimsResponse],
  )

  return {
    makeOptions,
    isMakesFetching,
    modelOptions,
    isModelsFetching,
    shortTrimOptions,
    isShortTrimsFetching,
  }
}
